export const AuthTypes = {
  signIn: "[Auth] SignIn",
  signOut: "[Auth] SignOut",
  nameChanged: "[Auth] NameChanged",
  logged: "[Auth] Logged",
  toRoute: "[Auth] ToRoute",
  updateInfo: "[Auth] Update Info",
  error: "[Auth] Error",
};
